import { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "../firebase/firebase"; // your firebase init
import { setPersistence, signInWithEmailAndPassword } from "firebase/auth";

const auth = getAuth(app);

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(undefined); // undefined = still loading

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser ?? null);
      });
  
      return () => unsubscribe(); // Cleanup listener
    }, []);
  
    // Still loading user state
    if (user === undefined) {
      return <div>Loading...</div>;
    }
  
    return (
        <AuthContext.Provider value={{ auth }}>
          {children}
        </AuthContext.Provider> )
  };

export function useAuth() {
  return useContext(AuthContext);
}

export async function getBearerToken() {
    const user = auth.currentUser;

    if(user){
        return await user.getIdToken();
    }
}

export async function signIn(data, persistence) {
    await setPersistence(auth, persistence);
    return await signInWithEmailAndPassword(auth, data.email, data.password);
}


// async function getBearerToken() {
//     return new Promise((resolve, reject) => {
//         const unsubscribe = onAuthStateChanged(auth, async (user) => {
//             unsubscribe(); // Clean up listener
//             if (user) {
//                 const token = await user.getIdToken();
//                 resolve(token);
//             } else {
//                 reject(new Error("User not authenticated"));
//             }
//         });
//     });
// }